export default __webpack_public_path__ + "static/media/bg.e8d340c3.png";